import { memo } from "react";
import { TextInput } from "react-admin";

const DetailInput = ({ detail, ...props }) => (
  <TextInput {...props} />
);

const propsAreEqual = (prevProps, nextProps) => {
  if (
    prevProps.detail === nextProps.detail &&
    prevProps.source === nextProps.source
  ) {
    // tidak perlu render ulang
    return true;
  }
  // perlu dirender ulang
  return false;
};

export default memo(DetailInput, propsAreEqual);
